import dynamic from "next/dynamic";
import MondayUniverseHomepageFirstFoldConfig from "./monday-universe-homepage-first-fold-config";
import MondayUniverseHomepageFirstFoldAdvancedConfig from "./monday-universe-homepage-first-fold-advanced-config";
const MondayUniverseHomepageFirstFoldComponent = dynamic(()=>import("./monday-universe-homepage-first-fold-component"));
export default {
    MondayUniverseHomepageFirstFoldComponent,
    MondayUniverseHomepageFirstFoldConfig,
    MondayUniverseHomepageFirstFoldAdvancedConfig
};
